<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>车辆维护</el-breadcrumb-item>
            <el-breadcrumb-item>车辆管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getcheliangList" @change="getcheliangList">
                        <el-button slot="append" icon="el-icon-search" @click="getcheliangList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="get_cheliang_edit" v-if="true">添加车辆</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="cheliangList" style="width: 100%" border stripe>
                        <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                        <el-table-column prop="uid" label="序号" width="auto"></el-table-column>
                        <el-table-column prop="bianhao" label="编号" width="auto"></el-table-column>
                        <el-table-column prop="paizhao" label="牌照" width="auto"></el-table-column>
                        <el-table-column label="车型选择" width="500">
                            <template v-slot="scope">
                                {{ scope.row.chexing01 }}: {{ scope.row.chexing02 }}: {{ scope.row.chexing03 }}: {{
                                    scope.row.chexing04 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="color" label="颜色" width="auto"></el-table-column>
                        <el-table-column prop="waiguan" label="外观" width="auto"></el-table-column>
                        <el-table-column prop="add_time" label="加入时间"></el-table-column>
                        <el-table-column label="操作">
                            <template v-slot="scope">
                                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="添加车辆外观" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-aim" @click="showWaiguanDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="deleteForm(scope.row.uid)"></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip class="item" effect="dark" content="设置为白名单" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-coordinate" circle size="mini"
                    @click="baiMingdan(scope.row.uid,scope.row.cheliang_flag_baiMingdan)"></el-button>
                </el-tooltip> -->
                                <el-tooltip class="item" effect="dark" content="车辆回访" placement="top" :enterable="false"
                                    style="display: none;">
                                    <el-button type="success" icon="el-icon-orange"
                                        @click="showHuifangDialog(scope.row.uid)" circle size="mini"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>

            <!-- 添加车辆部分 -->
            <!-- 管理调用 -->
            <el-dialog title="添加车辆" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
                <cheliangAdd ref="cheliangAdd" @getCheliangNewUid="getCheliangNewUid" :diaoyongType="1" :key="datekey"
                @getCheliangClose="getCheliangClose"   :editUid="editUid" :caozuoType="caozuoType">
                </cheliangAdd>
            </el-dialog>
            <el-dialog title="添加车辆外观" :visible.sync="waiguanDialogVisible" width="50%" @close="addDoalogClosed">
                <waiguanAdd ref="cheliangAdd" @getWaiguanNewUid="getWaiguanNewUid" :diaoyongType="1" :key="datekey"  @getWaiguanclose="getWaiguanclose"
                    :editUid="0" :cheliang_uid="cheliangUid" :caozuoType="1">
                </waiguanAdd>
            </el-dialog>

        </el-card>
    </div>
</template>
<script>
import cheliangAdd from './module/cheliang_add.vue'
import waiguanAdd from './module/waiguan_add.vue'
import { checkMobileTest, checkSfzId } from './config/validator';
import { ref } from 'vue';
export default {
    components: {
        cheliangAdd: cheliangAdd,
        waiguanAdd: waiguanAdd
    },
    data() {
        return {
            cheliangUid: 0,
            datekey: Date.now(),
            cheliangLy_options: [
                {
                    value: 1,
                    label: '车辆介绍'
                },
                {
                    value: 2,
                    label: '回访车辆'
                },
                {
                    value: 3,
                    label: '上门车辆'
                }
            ],
            cheliang_options: [
                {
                    value: 1,
                    label: '初级车辆'
                },
                {
                    value: 2,
                    label: '中级车辆'
                },
                {
                    value: 3,
                    label: '高级车辆'
                }
            ],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'cheliang_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            huifang_isDisable: false,
            add_isDisable: false,
            cheliangList: [],
            xiaoquList: [],
            //  recordCount: 0,
            total: 0,
            waiguanDialogVisible: false,
            editDialogVisible: false,
            addDialogVisible: false,
            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_cheliang_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_switch: true
            },
            caozuoType: 0, // 操作类型 1 是添加 2是删除
            editUid: 0, // 修改uid
            addForm: {
                C_type: 'cheliang_add',
                uid: 0,
                cheliang_bianhao: '',
                cheliang_name: '',
                cheliang_mob: '',
                cheliang_addr: '',
                cheliang_sfz_bianhao: '',
                cheliang_level: '',
                cheliang_memo: '',
                username: '',
                password: '123456'
            },
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                cheliang_name: [
                    { required: true, message: '请输入车辆名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],

                cheliang_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.cheliang_mob
                        )
                    }
                ],
                cheliang_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.cheliang_sfz_bianhao
                        )
                    }
                ]
            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getcheliangList()
    },

    methods: {
      
        getWaiguanclose(data) {
            this.waiguanDialogVisible = false 
        },
        getWaiguanNewUid(data) {
            this.waiguanDialogVisible = false
        }, 
        getCheliangClose(data) {
            this.addDialogVisible = false
        },
        getCheliangNewUid(data) {
            // 车辆添加返回的结果，可以读取车辆信息，在这里，只需要关闭窗口就好
            this.getcheliangList()
            this.addDialogVisible = false
            console.log(100, data)
        },
        async get_cheliang_edit() {
            this.addDialogVisible = true; // 要先打开才能调用
            // 通过更改组件的key 值，强制组件进行实时更新，每次出发create 函数
            this.datekey = Date.now()
            this.editUid = 0
            this.caozuoType = 1
            // 
        },
        async getcheliangList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data)[0].dataList)
            this.cheliangList = JSON.parse(res.data)[0].dataList

            if (!this.cheliangList) return;
            this.cheliangList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getcheliangList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getcheliangList();
        },
        showEditDialog(uid) {
            // this.cheliangInfo(uid);
            this.editUid = uid // 写uid
            this.caozuoType = 2

            this.datekey = Date.now() // 强制更新
            this.addDialogVisible = true;
        },
        showWaiguanDialog(uid) {
            // this.cheliangInfo(uid);
            this.cheliangUid = uid // 写外观uid
            this.caozuoType = 2
            
            this.datekey = Date.now() // 强制更新
            this.waiguanDialogVisible = true;
        },
        addDoalogClosed() {
            this.$refs.cheliangAdd.resetForm();
        },
        async Info(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'cheliang_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.editForm = JSON.parse(res.data)[0].data[0];
            this.huifangForm.huifang_cheliang_uid = JSON.parse(res.data)[0].data[0].uid;
        },

        async deleteForm(cheliangUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'cheliang_del',
                C_data1: cheliangUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getcheliangList();
        },

        // 设置白名单
        async baiMingdan(cheliangUid, baiMingdanFlag) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            var flag = 0
            if (baiMingdanFlag) flag = 0
            else flag = 1
            const comfirmResult = await this.$confirm(
                '确定要设置为白名单吗, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消');

            const { data: res } = await this.$http.post('api', {
                C_type: 'cheliang_baiMingdan',
                cheliangUid: cheliangUid,
                baiMingdanFlag: flag
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('设置失败');
                return;
            }
            this.$message.success('设置成功');
            this.getcheliangList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
